import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { TrackByFunctions } from '@principle-theorem/ng-shared';
import {
  CHART_VIEWS,
  ChartView,
} from '@principle-theorem/principle-core/interfaces';

@Component({
  selector: 'pr-chart-view-selector',
  templateUrl: './chart-view-selector.component.html',
  styleUrls: ['./chart-view-selector.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButton, MatMenuModule, MatDivider],
})
export class ChartViewSelectorComponent {
  trackByView = TrackByFunctions.variable<ChartView>();
  viewGroups: ChartView[][] = [CHART_VIEWS];
  @Input() view: ChartView = ChartView.Adult;
  @Output()
  selectionChange: EventEmitter<ChartView> = new EventEmitter<ChartView>();

  select(view: ChartView): void {
    this.view = view;
    this.selectionChange.emit(this.view);
  }
}
